import Modal from 'components/Common/Modal/Modal'
import { ResponsiveGeometryViewer } from 'components/Common/ResponsiveGeometryViewer'
import PropTypes from 'prop-types'
import React from 'react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPartsStepAnalysisByPartsIds } from 'store/actions'

const GeometryViewerModal = ({
	isGeometryViewerModalOpen,
	closeGeometryViewerModal,
	geometryViewerData,
	stepModelSrc,
	hideData,
}) => {

	const [fetchingStepAnalysis, setFetchingStepAnalysis] = useState(null)

	const { analyses } = useSelector((/** @type {StoreState} */ state) => state.Parts)

	const dispatch = useDispatch()

	useEffect(() => {
		if (analyses?.[geometryViewerData.partId] == null && fetchingStepAnalysis != geometryViewerData.partId) {
			setFetchingStepAnalysis(geometryViewerData.partId)
			dispatch(getPartsStepAnalysisByPartsIds(geometryViewerData.partId))
		}
	}, [geometryViewerData])

	const stepAnalysis = analyses?.[geometryViewerData?.partId]

	return <Modal
		isOpen={isGeometryViewerModalOpen}
		closeModal={closeGeometryViewerModal}
		dontShowCloseButton={true}
		className={'ResponsiveGeometryViewer'}
		body={
			<ResponsiveGeometryViewer
				modelSrc={geometryViewerData.modelSrc}
				stepModelSrc={stepModelSrc}
				partName={geometryViewerData.partName}
				partId={geometryViewerData.partId}
				size={geometryViewerData.size}
				weight={geometryViewerData.weight}
				hideData={hideData}
				stepAnalysis={stepAnalysis}
			/>
		}
	/>
}

GeometryViewerModal.propTypes = {
	isGeometryViewerModalOpen: PropTypes.bool,
	closeGeometryViewerModal: PropTypes.func,
	geometryViewerData: PropTypes.object,
}

export default GeometryViewerModal
